Vue.component('custom-options', require('./components/product/CustomOptions.vue').default);
const featureProducts = document.querySelectorAll(".feature-product-custom-options");
Array.prototype.forEach.call(featureProducts, (el, index) => new Vue({el}));